<template>
  <div>
    <div class="topup-back">
      <div v-if="isLoading" class="loading" v-html="$t('view.unregister.loading')"></div>
      <div v-if="!isLoading">
        <div>
          <div class="text" v-if="isStatusUnsubscribe">
            <h1 v-html="$t('view.unregister.title1ok')"></h1>
            <p v-html="$t('view.unregister.title2ok')"></p>
          </div>
          <div class="text" v-if="!isStatusUnsubscribe">
            <h1 v-html="$t('view.unregister.title1error')"></h1>
            <p v-html="$t('view.unregister.title1error')"></p>
          </div>
          <div class="button">
            <button id="topup-again" type="button" @click="goToTopup">{{ $t('view.unregister.buttonTopup') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UnsubscribeMixin from '@/common/mixins/views/Unsubscribe.mixin'

export default {
  name: 'Unregister',
  mixins: [UnsubscribeMixin],
  mounted () {
    /* global _paq */
    _paq.push(['trackPageView'])
  }
}
</script>

<style src="../assets/scss/back.scss" lang="scss"></style>
